import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import createAxiosInstance from '../api';
import AuthLayout from '../pages/layout/AuthLayout';
import { menuItems } from '../pages/auth/sidebar';
import { useHook as CustomerHook } from '../pages/auth/profileManagement/useHook';

interface ProtectRouteProps {
  // eslint-disable-next-line
  component: React.ComponentType<any>;
  Header_text: string;
  pagename?: string;
  intialroute?: string;
  userDetails?: UserDetails;
  id: string;
}

export interface MenuItem {
  label: string;
  icon: React.ReactElement;
  subMenu?: SubMenuItem[];
  submenuitems: string[];
  to?: string;
  route: string;
  id?: string;
  activeMenuIcon: React.ReactElement;
}

interface SubMenuItem {
  label: string;
  menu: string;
  permissionname: string;
  icon: (isActive: boolean) => React.ReactElement;
  to: string;
  id?: string;
}

interface UserDetails {
  firstName: string;
  lastName: string;
  email: string;
  avatar: string;
  roles: string[];
}

interface PagePermission {
  permissions: string[];
}

const intialuserdetails = {
  firstName: '',
  lastName: '',
  email: '',
  avatar: '',
  roles: [],
};

const permission_id = [
  'roles::assignPermission',
  'roles::get',
  'users::create',
  'users::updatePassword',
  'users::changeUserStatus',
  'roles::update',
  'roles::list',
  'roles::delete',
  'users::list',
  'users::update',
  'roles::create',
];

const ProtectRoute: React.FC<ProtectRouteProps> = ({
  component: Component,
  ...props
}) => {
  const token = localStorage.getItem('ICEMAKE');
  const axiosInstance = createAxiosInstance();
  const { fetchCustomerInfo } = CustomerHook();

  const navigate = useNavigate();
  const [pagePermissionIDs, setPagePermissionIDs] = useState<unknown[]>([]);
  const [pagePermission, setPagePermission] = useState<MenuItem[]>([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userDetails, setUserDetails] =
    useState<UserDetails>(intialuserdetails);

  useEffect(() => {
    if (token) {
      // validToken();
      setIsAuthenticated(true);
      setPagePermissionIDs(permission_id);
      setPagePermission(menuItems);
      getCustomerDetails();
    } else {
      navigate('/customerLogin');
    }
  }, []);

  const validToken = async () => {
    await axiosInstance
      .get('/valid', { headers: { Authorization: `Bearer ${token}` } })
      .then(async () => {
        setIsAuthenticated(true);
        const user = await getuserdetails();
        await getRolePermission(user);
      })
      .catch(() => {
        navigate('/customerLogin');
      });
  };

  const getuserdetails = async () => {
    return await axiosInstance
      .get('/user')
      .then(async (response) => {
        setUserDetails(response.data.data);
        return response.data.data;
      })
      .catch(() => {
        setUserDetails(intialuserdetails);
        return null;
      });
  };

  const filterpagepermission = (
    pagepermission: PagePermission[],
    user: UserDetails,
  ) => {
    const permissions: unknown[] = [
      ...new Set(pagepermission.flatMap((item) => item.permissions)),
    ].filter(Boolean);

    if (user?.email.includes('glacier-dev@maildrop.cc')) {
      setPagePermissionIDs(permission_id);
      setPagePermission(menuItems);
    } else {
      if (!permissions.includes(props.id)) {
        navigate('/equipment/ownedequipment');
      }

      if (permissions) {
        setPagePermissionIDs(permissions);
      }

      const filteredMenuItems: (MenuItem | null)[] = menuItems
        .map((menuItem: MenuItem) => {
          if (menuItem.id === 'dashboard') {
            return menuItem;
          }

          const subMenu: SubMenuItem[] | undefined = menuItem?.subMenu?.filter(
            (subMenuItem: SubMenuItem) => {
              return permissions.includes(subMenuItem.id);
            },
          );

          if (subMenu && subMenu.length > 0) {
            return {
              ...menuItem,
              subMenu,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);

      setPagePermission(filteredMenuItems.filter(Boolean) as MenuItem[]);
    }
  };

  const getRolePermission = async (user: UserDetails) => {
    await axiosInstance
      .get('/roleDetails')
      .then((response) => {
        if (response.data.data) {
          if (response.data.data) {
            filterpagepermission(response.data.data, user);
          }
        }
      })
      .catch(() => {
        setPagePermission([]);
      });
  };

  const getCustomerDetails = async () => {
    await fetchCustomerInfo().then((res: any) => {
      if (res && res?.errorCode == 401) {
        localStorage.clear();
        navigate('/customerLogin');
      }
    });
  };
  return isAuthenticated ? (
    <AuthLayout
      {...props}
      userDetails={userDetails}
      pagepermission={pagePermission}
    >
      <Component
        {...props}
        userDetails={userDetails}
        pagePermissionIDs={pagePermissionIDs}
        pagepermission={pagePermission}
      />
    </AuthLayout>
  ) : null;
};

export default ProtectRoute;
